import {Sidebar, User} from "@/api";
import {SET_SIDEBAR_IS_FETCH, SET_SIDEBAR} from "@/store/sidebar/mutations";
import widgetContentItemsActions from "@/store/general/widget-content-items/actions";

export const FETCH_SIDEBAR = 'fetchSidebar';
export const CREATE_PROJECT_BOOKMARK = 'createProjectBookmark';
export const DELETE_PROJECT_BOOKMARK = 'deleteProjectBookmark';

export default {
    ...widgetContentItemsActions,
    [FETCH_SIDEBAR](context) {
        context.commit(SET_SIDEBAR_IS_FETCH, true);

        return Sidebar()
            .get({projectId: context.state.sidebar.projectId})
            .then(response => {
                context.commit(SET_SIDEBAR, response.data);
            })
            .catch(error => {
                throw error;
            })
            .finally(() => context.commit(SET_SIDEBAR_IS_FETCH, false));
    },
    [CREATE_PROJECT_BOOKMARK](context, projectId) {
        return User(context.state.sidebar.user.id)
            .createProjectBookmark(projectId);
    },
    [DELETE_PROJECT_BOOKMARK](context, bookmarkId) {
        return User(context.state.sidebar.user.id)
            .deleteProjectBookmark(bookmarkId);
    }
}
